import Button from "@/components/ui/Button";
import Modal from "@/components/ui/Modal";
import { WALLET_RATES } from "@/pages/retailer/wallet/constants";

interface DeleteMandateModalProps {
  open: boolean;
  onClose: () => void;
  refNo: string;
  onConfirm: () => void;
  loading?: boolean;
  creationCharge?: number;
  isDraft?: boolean;
}

export default function DeleteMandateModal({
  open,
  onClose,
  refNo,
  onConfirm,
  loading,
  creationCharge = WALLET_RATES.CREATION_CHARGE,
  isDraft = false,
}: DeleteMandateModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={isDraft ? "Delete this draft?" : "Delete this mandate?"}
      footer={
        <div className="flex items-center justify-end gap-2.5 border-t border-line px-5 py-4">
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            {isDraft ? "Keep Draft" : "Keep Mandate"}
          </Button>
          <Button variant="danger" onClick={onConfirm} loading={loading}>
            {isDraft ? "Delete Draft" : "Delete Mandate"}
          </Button>
        </div>
      }
    >
      <p className="text-sm text-ink-secondary">
        {isDraft
          ? "This mandate is currently saved as a draft and no wallet charges have been applied."
          : `This mandate has not been authorised yet and can be deleted. The ₹${Number(creationCharge).toFixed(2)} charge is not refunded.`}
      </p>
      <p className="mt-2 text-sm text-ink-secondary">
        Reference <span className="font-medium text-ink">{refNo}</span> will be permanently removed.
      </p>
    </Modal>
  );
}